/* Galerie du Nuage — interactions du thème */
(function () {
  var RING = '0 0 0 3px #FFFFFF, 0 0 0 5px #23392F';

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var gallery = readJson('gn-gallery');
  var COLORS = readJson('gn-colors') || [];
  var state = { color: 0, thumb: 0, side: 'gauche', qty: 1, colorName: COLORS[0] ? COLORS[0].name : 'Sable' };
  var DEF = { x: 50, y: 64, w: 56 };
  var viz = { x: DEF.x, y: DEF.y, w: DEF.w, photo: false };
  var drag = null;

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function shade(hex, p) {
    var n = parseInt(hex.slice(1), 16);
    var t = p < 0 ? 0 : 255, a = Math.abs(p);
    function ch(c) { return Math.round((t - c) * a + c); }
    var r = ch(n >> 16), g = ch((n >> 8) & 255), b = ch(n & 255);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  /* ---------- Accordéons ---------- */
  function setAcc(btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var panel = btn.nextElementSibling;
    if (panel && panel.hasAttribute('data-acc-panel')) panel.hidden = !open;
    var minus = btn.querySelector('[data-icon="minus"]'), plus = btn.querySelector('[data-icon="plus"]');
    if (minus) minus.style.display = open ? '' : 'none';
    if (plus) plus.style.display = open ? 'none' : '';
  }

  /* ---------- Galerie produit ---------- */
  function renderGallery() {
    if (!gallery) return;
    var d = gallery[state.color][state.thumb];
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    main.style.background = d.bg; main.style.borderColor = d.border;
    var l = main.querySelector('[data-gallery-label]'), t = main.querySelector('[data-gallery-text]');
    if (l) { l.textContent = d.label; l.style.color = d.labelColor; }
    if (t) { t.textContent = d.text; t.style.color = d.textColor; }
    document.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.style.borderColor = Number(b.getAttribute('data-thumb')) === state.thumb ? '#23392F' : 'transparent';
    });
  }

  /* ---------- Coloris + angle, synchronisés partout ---------- */
  function syncSelections() {
    document.querySelectorAll('button[aria-pressed][aria-label]').forEach(function (b) {
      var grp = Array.prototype.slice.call(b.parentElement.querySelectorAll(':scope > button[aria-pressed][aria-label]'));
      var on = grp.indexOf(b) === state.color;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.style.boxShadow = on ? RING : 'none';
    });
    document.querySelectorAll('button[aria-pressed]:not([aria-label])').forEach(function (b) {
      var on = b.textContent.trim().toLowerCase().slice(-state.side.length) === state.side;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.style.borderColor = on ? '#23392F' : '#D6D3C9';
      b.style.background = on ? '#E4E8E1' : '#FFFFFF';
    });
    document.querySelectorAll('span > strong').forEach(function (s) {
      var lead = (s.parentElement.firstChild && s.parentElement.firstChild.nodeValue) || '';
      if (/^\s*Coloris/.test(lead)) s.textContent = state.colorName;
      if (/^\s*Angle/.test(lead)) s.textContent = state.side.charAt(0).toUpperCase() + state.side.slice(1);
    });
    renderGallery();
    renderSofa();
  }

  /* ---------- Visualiseur « chez vous » ---------- */
  function renderSofa() {
    var sofa = document.querySelector('[data-sofa]');
    if (!sofa) return;
    var c = COLORS[state.color] || { hex: '#D8CBB4', name: state.colorName };
    var tones = { sofaBase: c.hex, sofaDark: shade(c.hex, -0.2), sofaDeep: shade(c.hex, -0.32), sofaLight: shade(c.hex, 0.14) };
    document.querySelectorAll('[data-b-fill]').forEach(function (el) {
      var k = el.getAttribute('data-b-fill');
      if (tones[k]) el.setAttribute('fill', tones[k]);
    });
    var flip = document.querySelector('[data-b-transform="sofaFlip"]');
    if (flip) flip.setAttribute('transform', state.side === 'droite' ? 'translate(420 0) scale(-1 1)' : 'translate(0 0)');
    var dot = document.querySelector('[data-stage-dot]');
    if (dot) dot.style.background = c.hex;
    var label = document.querySelector('[data-stage-label]');
    if (label) label.textContent = (viz.photo ? 'Votre salon' : "Salon d'exemple") + ' · ' + state.colorName + ', angle ' + state.side;
    sofa.style.left = viz.x + '%';
    sofa.style.top = viz.y + '%';
    sofa.style.width = viz.w + '%';
    sofa.style.cursor = drag ? 'grabbing' : 'grab';
    var h = document.querySelector('[data-sofa-handle]');
    if (h) { h.style.left = (viz.x + viz.w / 2) + '%'; h.style.top = (viz.y + viz.w / 3) + '%'; }
    var r = document.querySelector('[data-viz-size]');
    if (r && Number(r.value) !== Math.round(viz.w)) r.value = String(Math.round(viz.w));
  }
  function showPhotoMode(on) {
    viz.photo = on;
    document.querySelectorAll('[data-if="hasPhoto"]').forEach(function (el) { el.hidden = !on; });
    document.querySelectorAll('[data-if="noPhoto"]').forEach(function (el) { el.hidden = on; });
  }
  function resetPos() { viz.x = DEF.x; viz.y = DEF.y; viz.w = DEF.w; }

  function loadPhoto(file) {
    var reader = new FileReader();
    reader.onload = function () {
      var raw = reader.result;
      var img = new Image();
      img.onload = function () {
        var url = raw;
        try {
          var k = Math.min(1, 1800 / Math.max(img.width, img.height));
          var cv = document.createElement('canvas');
          cv.width = Math.round(img.width * k); cv.height = Math.round(img.height * k);
          cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
          url = cv.toDataURL('image/jpeg', 0.86);
        } catch (e) { url = raw; }
        var photo = document.querySelector('[data-stage-photo]');
        if (photo) photo.src = url;
        resetPos(); showPhotoMode(true); renderSofa();
      };
      img.onerror = function () {
        var photo = document.querySelector('[data-stage-photo]');
        if (photo) photo.src = raw;
        resetPos(); showPhotoMode(true); renderSofa();
      };
      img.src = raw;
    };
    reader.readAsDataURL(file);
  }

  function startDrag(e, mode) {
    var stage = e.target.closest('[data-stage]');
    if (!stage) return;
    var r = stage.getBoundingClientRect();
    var target = e.currentTarget || e.target;
    try { target.setPointerCapture(e.pointerId); } catch (err) {}
    drag = { mode: mode, sx: e.clientX, sy: e.clientY, x0: viz.x, y0: viz.y, w0: viz.w, rw: r.width || 1, rh: r.height || 1, el: target };
    e.preventDefault();
    renderSofa();
  }
  function onMove(e) {
    if (!drag) return;
    var dx = (e.clientX - drag.sx) / drag.rw * 100, dy = (e.clientY - drag.sy) / drag.rh * 100;
    if (drag.mode === 'move') { viz.x = clamp(drag.x0 + dx, 0, 100); viz.y = clamp(drag.y0 + dy, 0, 100); }
    else viz.w = clamp(drag.w0 + dx * 2, 18, 98);
    renderSofa();
  }
  function onUp() { if (drag) { drag = null; renderSofa(); } }

  var sofaEl = document.querySelector('[data-sofa]');
  var handleEl = document.querySelector('[data-sofa-handle]');
  if (sofaEl) {
    sofaEl.addEventListener('pointerdown', function (e) { startDrag(e, 'move'); });
    sofaEl.addEventListener('pointermove', onMove);
    sofaEl.addEventListener('pointerup', onUp);
    sofaEl.addEventListener('pointercancel', onUp);
    sofaEl.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 6 : 2, k = e.key;
      if (k === 'ArrowLeft') viz.x -= step; else if (k === 'ArrowRight') viz.x += step;
      else if (k === 'ArrowUp') viz.y -= step; else if (k === 'ArrowDown') viz.y += step;
      else if (k === '+' || k === '=') viz.w += step; else if (k === '-' || k === '_') viz.w -= step;
      else return;
      e.preventDefault();
      viz.x = clamp(viz.x, 0, 100); viz.y = clamp(viz.y, 0, 100); viz.w = clamp(viz.w, 18, 98);
      renderSofa();
    });
  }
  if (handleEl) {
    handleEl.addEventListener('pointerdown', function (e) { e.stopPropagation(); startDrag(e, 'resize'); });
    handleEl.addEventListener('pointermove', onMove);
    handleEl.addEventListener('pointerup', onUp);
    handleEl.addEventListener('pointercancel', onUp);
  }
  document.querySelectorAll('[data-viz-size]').forEach(function (r) {
    r.addEventListener('input', function () { viz.w = clamp(Number(r.value) || DEF.w, 18, 98); renderSofa(); });
  });
  document.querySelectorAll('[data-viz-file]').forEach(function (inp) {
    inp.addEventListener('change', function () {
      var f = inp.files && inp.files[0];
      if (f && /^image\//.test(f.type)) loadPhoto(f);
      inp.value = '';
    });
  });

  /* ---------- Clics ---------- */
  document.addEventListener('click', function (e) {
    var acc = e.target.closest('button[data-acc]');
    if (acc) {
      var open = acc.getAttribute('aria-expanded') !== 'true';
      setAcc(acc, open);
      var list = acc.parentElement && acc.parentElement.parentElement;
      if (open && list) list.querySelectorAll(':scope > div > button[data-acc]').forEach(function (b) { if (b !== acc) setAcc(b, false); });
      return;
    }
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) { state.thumb = Number(thumb.getAttribute('data-thumb')); renderGallery(); return; }

    var pressed = e.target.closest('button[aria-pressed]');
    if (pressed) {
      if (pressed.hasAttribute('aria-label')) {
        var grp = Array.prototype.slice.call(pressed.parentElement.querySelectorAll(':scope > button[aria-pressed][aria-label]'));
        state.color = Math.max(0, grp.indexOf(pressed));
        state.colorName = pressed.getAttribute('aria-label');
      } else {
        state.side = pressed.textContent.trim().replace(/^Angle\s+/i, '').toLowerCase();
      }
      syncSelections();
      return;
    }
    if (e.target.closest('[data-viz-recenter]')) { resetPos(); renderSofa(); return; }
    if (e.target.closest('[data-viz-sample]')) {
      var photo = document.querySelector('[data-stage-photo]'); if (photo) photo.removeAttribute('src');
      resetPos(); showPhotoMode(false); renderSofa(); return;
    }
    var qplus = e.target.closest('[data-qty-plus]'), qminus = e.target.closest('[data-qty-minus]');
    if (qplus || qminus) {
      var input = (qplus || qminus).parentElement.querySelector('[data-qty-input]');
      if (input) {
        var v = Math.max(1, Math.min(9, (parseInt(input.value, 10) || 1) + (qplus ? 1 : -1)));
        input.value = String(v);
      }
      return;
    }
  });

  /* Les formulaires (newsletter, contact, ajout panier) sont de vrais formulaires Shopify :
     on ne bloque plus leur envoi ici, Shopify les traite normalement. */

  renderGallery();
  renderSofa();
})();
